import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CPProductResponse, ProductCP } from 'src/app/models/product-cp';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { ProductCpService } from 'src/app/services/product-cp.service';
import { ProductService } from 'src/app/services/product.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-products-cp',
  templateUrl: './products-cp.component.html',
  styleUrls: ['./products-cp.component.scss']
})
export class ProductsCpComponent implements OnInit {

  productsCP: CPProductResponse[] = [];
  creating = false;
  loading = false;
  loadingData = false;
  filterWord: string = "";
  filterProductsCPP: CPProductResponse[] = [];

  products: ProductResponse[] = [];
  providers: VendorResponse[] = [];
  inputs = {
    provider: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        measurement: null
      }
    }
  }
  filterProducts: ProductResponse[] = [];
  filterProviders: VendorResponse[] = [];
  currentProduct: ProductResponse;
  currentProvider: VendorResponse;
  timeout = null;
  showItems: { [key: number]: boolean } = {};

  constructor(
      private vendorService: VendorService,
      private productService: ProductService,
      private productCpService: ProductCpService,
      private toastrService: ToastrService
    ) { }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getProviders("");
    this.getProducts("");
    // this.searching();
  }

  getProviders(clue) {
    this.vendorService.getProvidesByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.filterProviders = this.providers;
        if (this.filterProviders.length == 0) {
          this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
        } else if (this.filterProviders.length == 1) {
          this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProductParameters(filterWord: any) {
    this.loadingData = true;
    this.productCpService.getAssigProviderProductParameters(filterWord).subscribe({
      next: (response: ResponseObject) => {
        this.productsCP = response.data;
        this.filterProductsCPP = this.productsCP;
        this.loadingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
        this.loadingData = false;
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProvider(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.provider.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProviders(inputValue);
    }, 500);
  }

  checkProvider(vendor: VendorResponse) {
    this.inputs.provider.class = "fa-circle-check";
    this.inputs.provider.verified = true;
    this.inputs.provider.data = vendor;
    this.inputs.provider.value = vendor.name;
    this.currentProvider = vendor;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    this.currentProduct = product;
  }

  createProductCP() {
    if (this.currentProvider == null || this.currentProduct == null) {
      return;
    }

    this.loading = true;
    this.productCpService.getIsExisteAssign(this.currentProvider.id, this.currentProduct.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          this.toastrService.error("Ya existe esta asignacion", "Error");
          this.loading = false;
        } else {
          this.addAssigment();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear la asingacion", "Error");
        this.loading = false;
      }
    });

  }

  addAssigment() {
    let data = {
      vendorId: this.currentProvider.id,
      productId: this.currentProduct.id,
    }
    this.productCpService.createProductCP(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Asignacion Creada Correctamente", "Exito");
        this.searching();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear la asingacion", "Error");
        this.loading = false;
      }
    });
  }

  get verifyForm() {
    if (this.currentProvider == null || this.currentProduct == null) {
      return false;
    }
    return true;
  }

  showItemsProduct(item: CPProductResponse) {
    if (!this.showItems[item.vendorData.id])
      this.showItems[item.vendorData.id] = true;
    else
      this.showItems[item.vendorData.id] = !this.showItems[item.vendorData.id];
  }

  deleteProductCP(item: ProductCP) {
    this.productCpService.deleteProductCPById(item.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Se eliminio la asignacion correctamente", "Exito");
        this.searching();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Erro al eliminar la asignacion", "Error");
      }
    });
  }

  searching() {
    this.getProductParameters(this.filterWord);
  }
}
